export const toArray = <T>(arrayLike: ArrayLike<T>): T[] => {
	return Array.prototype.slice.call(arrayLike);
};

export const tweenProp = (start: number, end: number, position: number) =>
	start + (end - start) * position;
